import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateTestDto } from 'src/app/core/classes/create-test-dto';
import { LinkedAccountResult } from 'src/app/core/interfaces/linked-account-result';
import { HttpService } from 'src/app/core/services/http/http.service';
import { EndPoints } from 'src/app/shared/EndPoints';
import { environment } from 'src/environments/environment';
import { ParameterDto } from '../create-test/create-test.component';

import { TestRequestDto, TestsResponse } from './../../../../core/classes/tests';

@Injectable({
  providedIn: 'root'
})
export class TestsService {
  private CPPortalBaseUrl: string;

  constructor(private httpService: HttpService) {
    this.CPPortalBaseUrl = environment.customerPortalServiceUrl;
  }

  getTestsData(request: TestRequestDto): Observable<TestsResponse> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.getTests, request);
  }

  exportTestsData(request: TestRequestDto): Observable<TestsResponse> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.exportTestsData, request);
  }

  public getLinkedAccountsByBU(buCode: string) {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.GET_LINKEDACCOUNTS_BY_BU + buCode);
  }

  public getLinkedAccounts(userId: string): Observable<LinkedAccountResult[]> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.GET_LINKED_ACCOUNTS_BY_ID);
  }

  public CheckBUTestCode(buCode: string, testCode: string, labPortTestCode: string) {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.CHECKUNIQUE_BU_TESTCODES
      + buCode + '/' + testCode + '/' + labPortTestCode);
  }
  public getQuestionsForBu(buCode): Observable<any> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.GetQuestionsByBUCode + buCode);
  }

  public getTestDetailsByLabportTestCode(testId: string): Observable<CreateTestDto> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getTestByTestId + testId);
  }

  public getParametersByTestId(testId: string): Observable<ParameterDto> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.GetParametersByTestId + testId);
  }

  public createTest(request: any): Observable<any> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.createTest, request);
  }

  public editTest(request: any): Observable<any> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.editTest, request);
  }

  public getTestSearchByName(request: any): Observable<any> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.GetTestSearchByName, request);
  }

  public getSubContractBUDetailsByBU(buCode): Observable<any> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getSubContractBUDetailsByBU + buCode);
  }

  public InstructionDocDownload(request: any): Observable<any> {
    return this.httpService.Post(this.CPPortalBaseUrl + EndPoints.downloadTestInstruction, request);
  }

  public getTestsByBU(buCode): Observable<any> {
    return this.httpService.Get(this.CPPortalBaseUrl + EndPoints.getTestsByBu + buCode);
  }

  public validateParameters(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('File', file);
    const url = `${this.CPPortalBaseUrl}${EndPoints.validateTestParameters}`;
    return this.httpService.Post(url, formData);
  }

  public validateEdiParameters(file: File, testId: string): Observable<any> {
    const formData = new FormData();
    formData.append('File', file);
    const url = `${this.CPPortalBaseUrl}${EndPoints.validateTestParameters}/${testId}`;
    return this.httpService.Post(url, formData);
  }

  public downloadTestParameterUploadTemplate() {
    const url = `${this.CPPortalBaseUrl}${EndPoints.downloadParameterUploadTemplate}`;
    return this.httpService.Get(url);
  }
}
